import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Form } from 'reactstrap';
import SelectInput from '../Common/Inputs/SelectInput';
import { Row, Col, Label } from 'reactstrap';
import Inputs from '../Common/Inputs/Inputs';
import SelectSearchChecboxOptions from './SelectSearchChecboxOptions';
import { useSelector, useDispatch } from 'react-redux';
import { getCohorts } from '../../actions/Cohort/CohortAction';
import Api from '../../Api';
import Constants from '../../Constants';
import FlashMessages from '../Common/Messages/FlashMessages';
import { setNavigateToMsg } from '../../actions/Notifications/ScreenReaderInit';
import { setPageTitle, getReportLink, triggerNavFocus } from '../../actions/Page/PageAction';
import { isEmpty } from 'ramda';
import { Button } from '../Common';
import { hasAnyError, validateAny, validateCohortName } from '../Common/Errors/Errors';

const { layoutGridSize, formLabelSize, formLabelSizeSm } = Constants;

const CreateCohort = ({ onReportProcess }) => {
  const [state, setState] = useState({
    msgType: '',
    message: '',
    msgShow: false,
    cohortName: '',
    formInputsValidation: {},
    slectCohort: 0,
    clientIdsSelected: [],
    saveCohortOption: false,
    slectedName: '',
    formSubmitted: false,
    isLoading: false,
  });

  const cohortFormRef = useRef(null);
  const selectedCohortRef = useRef(null);

  const {
    impersonate,
    sideNavToggle,
    reportLinkObj,
    cohorts,
    cohortsOrgs,
    cohortsOrgsLoading,
    cohortsSelections,
    casDetails,
  } = useSelector((state) => ({
    impersonate: state.Impersonate.impersonate.impersonate,
    sideNavToggle: state.Page.sideNavToggle,
    reportLinkObj: state.Page.reportLink,
    cohorts: state.Cohort.cohorts,
    cohortsOrgs: state.CohortsOrgs.cohortsOrganizations,
    cohortsOrgsLoading: state.CohortsOrgs.loading,
    cohortsSelections: state.CohortsSelections.CohortsSelections,
    casDetails: state.AppSession.activeCasDetails,
  }));

  const dispatch = useDispatch();

  const handleInputChange = (inputFields, value, valueParse) => {
    if (inputFields.name === 'slectCohort') {
      setState((prev) => ({
        ...prev,
        isLoading: true,
      }));
      value = parseInt(valueParse, 10);
      if (value !== 0) {
        const api = new Api();
        let url = Constants.apiUrls.cohorts + '/' + value;
        api.getData(url).then((resp) => {
          setState((prev) => ({
            ...prev,
            clientIdsSelected: resp.clientIdsSelected,
            slectedName: resp.name,
            slectCohort: resp.id,
            isLoading: false,
          }));
          selectedCohortRef.current?.focus();
        });
      } else {
        setState((prev) => ({
          ...prev,
          clientIdsSelected: [],
          slectedName: '',
        }));
      }
    }

    setState((prev) => ({
      ...prev,
      [inputFields.name]: value,
    }));
  };
  useEffect(() => {
    console.log('DIDMOUNT ... ');
    state.clientIdsSelected;
  }, []);
  useEffect(() => {
    setState((prev) => ({
      ...prev,
      clientIdsSelected: [],
    }));
  }, [cohortsOrgs]);
  useEffect(() => {
    dispatch(setPageTitle('Cohort Generate'));

    if (casDetails.casId !== '') {
      dispatch(getCohorts(casDetails.casId, 'new'));
    }

    if (cohortFormRef.current) {
      cohortFormRef.current.focus();
    }

    if (reportLinkObj.saved) {
      setState((prev) => ({
        ...prev,
        clientIdsSelected: reportLinkObj.cohortObj.clientIdsSelected,
        saveCohortOption: true,
      }));
    }

    dispatch(setNavigateToMsg(reportLinkObj.reportDisplayName));

    return () => {
      dispatch(setPageTitle());
    };
  }, [dispatch, casDetails.casId, reportLinkObj]);

  const saveCohortOption = (evt) => {
    setState((prev) => ({
      ...prev,
      saveCohortOption: !evt,
    }));
  };

  const submitAndGenerate = () => {
    const { saveCohortOption, cohortName, clientIdsSelected } = state;
    const formInputsValidation = {
      cohortName: saveCohortOption ? validateCohortName(cohortName) : '',
      clientIdsSelected: validateAny(clientIdsSelected.length >= cohortsSelections.numberSelectionsMinRequired),
    };

    const hasErrors = hasAnyError(formInputsValidation);

    setState((prev) => ({
      ...prev,
      formInputsValidation,
      formSubmitted: true,
    }));

    const reqPayload = {
      name: state.cohortName,
      clientIdsSelected: state.clientIdsSelected,
      casId: casDetails.casId,
    };

    if (state.slectCohort !== 0) {
      if (state.clientIdsSelected.length) {
        generateCohortCall({ ...reqPayload, name: state.slectedName });
      } else {
        setState((prev) => ({
          ...prev,
          msgType: 'error',
          message: 'Organizations not loaded please generate again',
          msgShow: true,
        }));
      }
    } else {
      !hasErrors && generateCohortCall(reqPayload);
    }
  };

  const generateCohortCall = (data) => {
    const myInit = { body: data };
    const api = new Api();
    const saveCohortOption = state.saveCohortOption ? 1 : 0;
    const url = Constants.apiUrls.saveCohort + saveCohortOption;
    api
      .postData(url, myInit)
      .then((resp) => {
        dispatch(getCohorts(casDetails.casId));
        setState((prev) => ({
          ...prev,
          msgType: 'success',
          message: 'cohort saved successfully',
          msgShow: true,
        }));
        let report = reportLinkObj;
        report.reportUrl = reportLinkObj.originalUrl + resp.cohortUrlParameters;
        report.filterByCohort = false;
        report.passByUD = true;
        report.cohortObj = data;
        report.saved = state.cohortName === '' && state.slectCohort === 0;
        dispatch(getReportLink(report));
        onReportProcess(true, 'cohort');
      })
      .catch((err) => {
        setState((prev) => ({
          ...prev,
          msgType: 'error',
          message: err,
          msgShow: true,
        }));
      });
  };

  const clientIdsSelectedEvent = (inputFields, id) => {
    const { clientIdsSelected, slectCohort } = state;
    if (state.slectCohort === 0) {
      const checkIndex = inputFields.clientIdsSelected?.indexOf(id);
      if (checkIndex !== -1) {
        inputFields.clientIdsSelected.splice(checkIndex, 1);
      } else if (inputFields.clientIdsSelected.length < cohortsSelections.numberSelectionsMaxAllowed) {
        inputFields.clientIdsSelected.push(id);
      }
      setState((prev) => ({
        ...prev,
        clientIdsSelected: inputFields.clientIdsSelected,
      }));
    }
  };

  const renderOrganizationList = (inputFields) => {
    const options = (cohortsOrgs || []).map((obj, index) => {
      const checkIndex = inputFields.indexOf(obj.id);
      return checkIndex > -1 ? (
        <li key={index} value={obj.id} className="fontSm-15 mBottom-10">
          <span>{obj.name}</span>
        </li>
      ) : null;
    });
    return options;
  };

  const hideFlashMessage = () => {
    setState((prev) => ({ ...prev, msg: '', msgType: '', msgShow: false }));
  };

  const defaultCohortOptions = {
    id: 0,
    name: 'Create New...',
  };
  const controlSize = layoutGridSize - formLabelSize;
  const controlSizeSm = layoutGridSize - formLabelSizeSm;
  return (
    <div className="reports init-focus__hidden" tabIndex="-1" ref={cohortFormRef}>
      <FlashMessages
        close={hideFlashMessage}
        type={state.msgType}
        msg={state.message}
        open={state.msgShow}
        classNames={'fl-create-cohort'}
        scope="CohortCreate"
      />
      <div className="mobile_margin signUp fontSm-15">
        <h1 className="cohort-heading ScalaSansComp pSm-10" id="app_page_title">
          <i className="far fa-star lsn-primary-color fontSm-24 pRight-10" />
          {reportLinkObj.reportDisplayName}
        </h1>
        <Form
          tabIndex={0}
          aria-label="Cohort Settings"
          onKeyDown={(e) => {
            if (e.target !== e.currentTarget) return;

            if (e.shiftKey && e.key === 'Tab' && !sideNavToggle) {
              e.preventDefault();
              dispatch(triggerNavFocus());
            }
          }}
          className="signUp-form margin-center">
          <h2 className="heading-h6-20">Cohort Settings</h2>
          <SelectInput
            onInputChange={handleInputChange}
            title="Select Cohort"
            name="slectCohort"
            required
            idOption={true}
            dataObj={[defaultCohortOptions, ...(cohorts || [])]}
            value={state.slectCohort}
          />

          <Row aria-live="polite">
            {state.slectCohort > 0 && !!state.slectedName ? (
              <Col
                className="input-left relative"
                sm={{ size: controlSizeSm, offset: formLabelSizeSm }}
                md={{ size: controlSize, offset: formLabelSize }}>
                <ul
                  tabIndex={0}
                  ref={selectedCohortRef}
                  aria-label={`selected cohort: ${state.slectedName} with the following organizations`}
                  className="listOfOrganization ul-cust no-focus">
                  {renderOrganizationList(state.clientIdsSelected)}
                </ul>
                <div className="anchorParent">
                  <Link to="/manageCohort" className="anchor lsn-primary-color" label="manageCohort">
                    {' '}
                    <i className="far fa-cog  lsn-primary-color mRight-5" />
                    Manage Cohorts
                  </Link>
                </div>
              </Col>
            ) : null}
          </Row>

          {state.slectCohort === 0 ? (
            <React.Fragment>
              <SelectSearchChecboxOptions
                required
                clientIdsSelectedEvent={clientIdsSelectedEvent}
                formSubmitted={state.formSubmitted}
                placeholder="Search Organizations"
                maxAllowed={cohortsSelections.numberSelectionsMaxAllowed}
                minRequired={cohortsSelections.numberSelectionsMinRequired}
                title={`Select ${cohortsSelections.numberSelectionsMinRequired} - ${cohortsSelections.numberSelectionsMaxAllowed} Organizations`}
                clientIdsSelected={state.clientIdsSelected}
                name="organization"
                busy={cohortsOrgsLoading && isEmpty(cohortsOrgs)}
                dataObj={cohortsOrgs}
                value={state.organization}
              />
              <Row className="mTop-15">
                <Label id={'saveCohort'} for="saveCohortCheckbox" sm={2} md={4} className="ScalaSansOT">
                  Save Cohort?
                </Label>
                <Col className="input-left relative v-middle-align" sm={10} md={8}>
                  <div
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        saveCohortOption(state.saveCohortOption);
                      }
                    }}
                    onClick={() => saveCohortOption(state.saveCohortOption)}
                    aria-checked={state.saveCohortOption}
                    tabIndex="0"
                    role={'checkbox'}
                    data-testid="saveCohortCheckbox"
                    aria-labelledby={'saveCohort'}
                    className="switch">
                    <span className="slider round"></span>
                    <input type="checkbox" id="saveCohortCheckbox" hidden />
                  </div>
                </Col>
              </Row>
              {state.saveCohortOption && (
                <div className="mTop-15">
                  <Inputs
                    onInputChange={handleInputChange}
                    errorMessages={state.formInputsValidation.cohortName}
                    required="required"
                    title="Saved Cohort Name"
                    id={'cohortName'}
                    name="cohortName"
                    placeholder="Cohort Name"
                    value={state.cohortName}
                  />
                </div>
              )}
            </React.Fragment>
          ) : null}

          <div className="text-center mTop-45">
            <Button
              isNew
              size="large"
              busy={state.isLoading}
              text="Generate Report"
              id="button-cohort-generate"
              onClick={submitAndGenerate}
            />
          </div>
        </Form>
      </div>
    </div>
  );
};

export default CreateCohort;
